import { cloneDeep } from "lodash-es";
import { nanoid } from "nanoid";

import { api, django } from "@/api";
import { Project } from "@/types";

export const newProject = (projectId: string, address: string) => {
  return {
    created: new Date().toJSON(),
    lateralID: nanoid(),
    originalAuthor: address,
    deleted: false,
    meta: "{}",
    publicID: nanoid(),
    slug: projectId,
    name: projectId,
    banner: "",
    description: "",
    icon: "",
  };
};

const formatProject = (p: { stream_id: string; stream_content: any }): Project => {
  const project: Project = cloneDeep(p.stream_content);
  project.id = p.stream_content.lateralID;
  project.ceramicID = p.stream_id;
  project.created = new Date(project.created);
  // @ts-ignore
  project.meta = JSON.parse(project.meta);
  // @ts-ignore
  delete project.lateralID;
  return project;
};

export const getProjects = async ({ signal }: { signal: AbortSignal }): Promise<Project[]> => {
  const response = await api.get(
    `/kjzl6hvfrbw6c5e090bdcz5j0852t4fq0281rngqt0cfikzppa8bdfqnza3jyun?` +
      new URLSearchParams({
        select: "stream_id,stream_content",
      }),
    { signal }
  );
  return response.data.map(formatProject);
};

export const getProjectTokenCounts = async (
  signal: AbortSignal | undefined,
  projectId?: string
): Promise<{ [key: string]: number }> => {
  const response = await django.get(`/editor/project/${projectId}/token_counts/`, {
    signal,
  });
  const regex = /lateral-ldg-(.*)-([A-Za-z0-9_-]{21})/;
  const newObj: { [key: string]: number } = {};
  Object.keys(response.data).map((key) => {
    const match = key.match(regex);
    if (match && match[1] == projectId) {
      newObj[match[2]] = response.data[key];
    }
  });

  return newObj;
};
